module.exports = __webpack_public_path__ + "img/emoji-dizzy.c391c2cc.svg";